module.exports = __webpack_public_path__ + "img/hb_zhTc.3ae49560.png";